module.exports = __webpack_public_path__ + "tip.c4843929.png";